import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
} from "reactstrap";
import withRouter from "components/Common/withRouter";
import Breadcrumb from "../../components/Common/Breadcrumb";
import avatar from "../../assets/images/profile-image.png";
import secureLocalStorage from "react-secure-storage";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";

const UserProfile = () => {
  const [userData, setUserData] = useState({
    email: "",
    username: "",
    id: "",
  });

  useEffect(() => {
    const fetchUserData = () => {
      const storedUser = secureLocalStorage.getItem("authUser");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        console.log(user);
        debugger;//
        setUserData({
          email: user.email || "",
          username: user.username || "",
          id: user.employeeId || "",
        });
      }
    };

    fetchUserData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="py-0 px-0">
          {/* <Breadcrumb title="Dashboard" breadcrumbItem="Profile" /> */}
          <PageSubHeader
            heading="User Profile"
            routePath="Home"
            pageName="User Profile"
          />

          <Row className="justify-content-center p-4">
            <Col lg="8">
              <Card>
                <CardBody>
                  <div className="text-center mb-4">
                    <img
                      src={avatar}
                      alt="User Avatar"
                      className="rounded-circle img-thumbnail"
                      style={{ width: "150px", height: "150px" }}
                    />
                  </div>

                  <Table bordered className="mb-0">
                    <tbody>
                      <tr>
                        <th scope="row" style={{ width: "30%" }}>
                          Username
                        </th>
                        <td>{userData.username}</td>
                      </tr>
                      <tr>
                        <th scope="row">Email</th>
                        <td>{userData.email}</td>
                      </tr>
                      <tr>
                        <th scope="row">Employee Id</th>
                        <td>{userData.id ? userData.id : "Not an Employee"}</td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
